import React, { Component } from 'react';
import logo from '../edge_logo_white_40.png';
import '../App.css';
import AuthProfileButton from './AuthProfileButton';

import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from "gatsby";
import 'bootstrap/dist/css/bootstrap.min.css';

class Header extends Component {
    render() {
        let commonClass = "header-text mr-3 sv-ml-3 nav-link";

        return (
            <Navbar collapseOnSelect expand="lg" className="App-header" variant="dark">
                <Navbar.Brand href="/">
                    <img src={logo} className="App-logo" alt="Edge.Poker - Know Your Hand" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" className="header-text custom-toggler"/>
                <Navbar.Collapse id="responsive-navbar-nav" className="sv-mt-2">
                    <Nav className="mr-auto lv-ml-5">
                        <Link to="/" activeClassName="link-disabled" className={commonClass}>App</Link>
                        <Link to="/how-to-use" activeClassName="link-disabled" className={commonClass}>How-to-Use</Link>
                        <Link to="/premium" activeClassName="link-disabled" className={commonClass}>Premium</Link>
                        <Link to="/resources" activeClassName="link-disabled" className={commonClass}>Resources</Link>
                        <NavDropdown title="More" id="more-dropdown" className="App-header-dropdown header-text mr-3 sv-ml-3 nav-link">
                            <NavDropdown.Item>
                                <Link to="/about" activeClassName="link-disabled" className={commonClass}>About</Link>
                            </NavDropdown.Item>
                            <NavDropdown.Item>
                                <Link to="/faqs" activeClassName="link-disabled" className={commonClass}>FAQs</Link>
                            </NavDropdown.Item>
                            <NavDropdown.Item>
                                <Link to="/contact-us" activeClassName="link-disabled" className={commonClass}>Contact Us</Link>
                            </NavDropdown.Item>
                        </NavDropdown>
                        
                    </Nav>
                    <AuthProfileButton/>
                </Navbar.Collapse>
            </Navbar>
        )
    }
}

export default Header;